import React, { useState } from "react";
import { User, UserPlus } from "lucide-react";
import "../styles/03-components/header.scss";
import { LoginModal } from "./LoginModal";
import { Link } from "react-router-dom";

export const Header = () => {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const handleLogin = () => {
    setIsLoginOpen(true);
  };

  const handleRegister = () => {
    console.log("Register clicked");
  };

  return (
    <header className="header">
      <div className="header__container">
        <Link to="/" className="header__logo">
          <h1 className="header__title">
            <span className="header__title__first">Off</span>Together
          </h1>
        </Link>

        {/* Navigation Links */}
        {/*  <div className="header__nav">
          <button
            className="header__btn header__btn--login"
            onClick={handleLogin}
          >
            <User className="header__icon" />
            Anmelden
          </button>

          <Link
            to="/register"
            className="header__btn header__btn--register"
            onClick={handleRegister}
          >
            <UserPlus className="header__icon" />
            Registrieren
          </Link>
        </div>
      </div>

      
      <LoginModal open={isLoginOpen} onOpenChange={setIsLoginOpen} /> */}
      </div>
    </header>
  );
};
